import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification, Modal } from 'antd'
import actions from './actions'
import { list, find, save, remove, copyContract, findSelectable } from '../../services/contract'
import { DEL_200_MSG, DEL_200_DESC } from '../../constants'

function* fetchContractsRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchContracts'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  } else {
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_CONTRACT,
    result,
  })
}

function* fetchContracts({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchContracts'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = size || localStorage.getItem('pageSize') || 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  // Safety: ensure size/index are always valid numbers
  size = parseInt(size, 10) || 15
  index = parseInt(index, 10) || 0
  searchTerm = searchTerm || '%20'
  orderBy = orderBy || '%20'
  localStorage.setItem('fetchContracts', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_CONTRACT,
    result,
  })
}

function* fetchContractEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_CONTRACT,
    result,
  })
}

function* fetchContractSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    // A dialog the user confirms with OK - the short corner toast was easy to miss.
    // (Errors: the request helper already shows the server's reason.)
    const german = (localStorage.getItem('locale') || '').indexOf('de') === 0
    const number = (values.values && values.values.contractNumber) || ''
    const texts = {
      created: german
        ? [
            'Projekt erstellt',
            `Das Projekt ${number} wurde erstellt und ist jetzt in Ihrer Projektliste.`,
          ]
        : ['Project created', `Project ${number} was created and is now in your project list.`],
      saved: german
        ? ['Projekt gespeichert', `Das Projekt ${number} wurde gespeichert.`]
        : ['Project saved', `Project ${number} was saved.`],
    }
    const [title, content] = result && result.created ? texts.created : texts.saved
    Modal.success({ title, content, okText: 'OK', centered: true })
  }
  yield put({
    type: actions.SAVE_CONTRACT_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_CONTRACTS,
  })
}

function* fetchContractDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_CONTRACT_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_CONTRACTS,
  })
}

function* fetchChooseContract(payload) {
  console.log('fetchChooseContract', payload)
  /* yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, param.id)
  console.log('fetchChooseContract', result)
  localStorage.setItem('contract', JSON.stringify(result))

  yield put({
    type: actions.SELECT_CONTRACT,
    result,
  }) */

  yield put({
    type: actions.REQUESTING,
  })
  yield put({
    type: actions.SELECT_CONTRACT,
    payload,
  })
  storeSelectedContract(payload)
}

// The selected project belongs to the BROWSER TAB (sessionStorage): a refresh or a
// link inside the tab keeps the tab's own project. localStorage only remembers the
// last project used anywhere, as the starting point for a brand-new tab. Before,
// every tab re-read the shared localStorage value on each page load, so a tab could
// silently switch to the project chosen in another tab - and saves then went to that
// project (live: work order 14R000020 moved from contract 14 to 16).
const CONTRACT_KEY = 'contract'

function storeSelectedContract(payload) {
  const json = JSON.stringify(payload)
  try {
    sessionStorage.setItem(CONTRACT_KEY, json)
  } catch (e) {
    // sessionStorage unavailable: the shared value below still works as before.
  }
  localStorage.setItem(CONTRACT_KEY, json)
}

function* loadContract() {
  let json = null
  try {
    json = sessionStorage.getItem(CONTRACT_KEY)
  } catch (e) {
    json = null
  }
  if (json === null) {
    // New tab: start from the last project used, then keep it for this tab only.
    json = localStorage.getItem(CONTRACT_KEY)
    if (json !== null) {
      try {
        sessionStorage.setItem(CONTRACT_KEY, json)
      } catch (e) {
        // ignore - see storeSelectedContract
      }
    }
  }
  const payload = json !== null ? JSON.parse(json) : null
  if (payload !== null) {
    yield put({
      type: actions.SELECT_CONTRACT,
      payload,
    })
  }
}

function* unSelectContract() {
  try {
    sessionStorage.removeItem(CONTRACT_KEY)
  } catch (e) {
    // ignore
  }
  localStorage.removeItem(CONTRACT_KEY)
  yield put({ type: actions.UNSELECT_CONTRACT_RECIEVED })
}

// A record of another project is open (see ContractMismatchAlert): select its project
// and reload, so the header, every dropdown and every save use that project.
function* switchContract({ contractID }) {
  const payload = yield call(findSelectable, contractID)
  if (!payload) {
    notification.error({
      message: 'Project not available',
      description: `Project ${contractID} could not be selected - you may not have access to it. Please select it from the project list.`,
    })
    return
  }
  yield put({ type: actions.SELECT_CONTRACT, payload })
  storeSelectedContract(payload)
  window.location.reload()
}

// IMPORTANT: pass the whole action to the service — the shared `postRequest`
// helper (services/api.js) reads `param.values` internally to get the actual
// body. If we only forward the inner `values`, the body becomes undefined and
// the API returns 415.
function* fetchCopyContract(action) {
  yield put({ type: actions.REQUESTING })
  try {
    const result = yield call(copyContract, action)
    if (result !== null) {
      notification.success({
        message: 'Project copied',
        description: 'Project copied successfully.',
      })
    } else {
      // The backend rejected the copy (e.g. contract number already used by an
      // ACTIVE project). Without this, the dialog just closes and the user
      // believes the new project silently "disappeared".
      notification.error({
        message: 'Copy failed',
        description:
          'The project was NOT copied. The contract number may already be in use by an active project - archived projects release their number.',
        duration: 0,
      })
    }
    yield put({ type: actions.COPY_CONTRACT_RECIEVED, result })
    yield put({ type: actions.RE_FETCH_CONTRACTS })
  } catch (e) {
    notification.error({
      message: 'Copy failed',
      description: (e && e.message) || 'Project could not be copied.',
    })
    yield put({ type: actions.COPY_CONTRACT_RECIEVED, result: null })
  }
}

export default function* rootSaga() {
  yield all([
    loadContract(),
    takeEvery(actions.UNSELECT_CONTRACT, unSelectContract),

    takeEvery(actions.CHOOSE_CONTRACT, fetchChooseContract),
    takeEvery(actions.SWITCH_CONTRACT, switchContract),
    takeEvery(actions.FETCH_CONTRACTS, fetchContracts),
    takeEvery(actions.FETCH_CONTRACT, fetchContractEdit),
    takeEvery(actions.SAVE_CONTRACT, fetchContractSave),
    takeEvery(actions.DELETE_CONTRACT, fetchContractDelete),
    takeEvery(actions.RE_FETCH_CONTRACTS, fetchContractsRefresh),
    takeEvery(actions.COPY_CONTRACT, fetchCopyContract),
  ])
}
